// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import routers from './routers'
import axios from 'axios'
import {post,fetch,patch,put} from './api'
import global from './components/global'
import wx from 'weixin-js-sdk';
import $ from 'jquery'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import 'vue-layer-mobile/need/layer.css'
import layer from 'vue-layer-mobile'
import vueDanmaku from 'vue-danmaku'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
import './css/animate.css'
import imagesLoaded from 'vue-images-loaded'
import ba from 'vue-ba'
import VueParticles from 'vue-particles'

Vue.use(VueParticles)

Vue.use(ba,'7e78b1a7021c2a8235148f6f14d452a3')
Vue.use(ba, { siteId: "7e78b1a7021c2a8235148f6f14d452a3" });
Vue.use(AlloyFingerPlugin,{
  AlloyFinger
})
Vue.use(VueAwesomeSwiper)
Vue.use(vueDanmaku)
Vue.use(layer)
Vue.use(VueCookies);
Vue.use(Vuex)
Vue.use(global)
Vue.prototype.global = global
Vue.prototype.$post=post
Vue.prototype.$fetch=fetch
Vue.prototype.$patch=patch
Vue.prototype.$put=put
Vue.config.productionTip = false
Vue.use(VueRouter)
const router = new VueRouter({
  routes: routers
})
const store = new Vuex.Store({
  // 定义状态
  state: {
    recruitScrollY:0
  },

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'

});
$.ajaxSetup({
  crossDomain: true,
  xhrFields: {
    withCredentials: true
  },
  headers: {
    "X-Requested-With": "XMLHttpRequest" ,
    "Content-Type": "application/x-www-form-urlencoded"
  }
});
export default{

}



// WEBPACK FOOTER //
// ./src/main.js